"use client"

import { useTranslations } from "@/lib/intl/use-translations"
import { cn } from "@/lib/utils"

/**
 * One-line legend for the sample report's findings categories, ordered from
 * least to most significant. Uses the same labels and dot colours as the
 * findings pills so the order reads at a glance (AHD-13093).
 */
const LEVELS = [
  { key: "noFindingSingular", dot: "bg-neutral-300" },
  { key: "observation", dot: "bg-deep-green-500" },
  { key: "minor", dot: "bg-bright-green-500" },
  { key: "followUpRecommended", dot: "bg-terracotta-300" },
] as const

export function FindingsLegend({ className }: { className?: string }) {
  const t = useTranslations("report")
  return (
    <p
      data-testid="findings-legend"
      className={cn(
        "type-body-sm flex flex-wrap items-center gap-x-1.5 gap-y-1 text-neutral-600",
        className
      )}
    >
      <span className="font-medium text-neutral-800">
        {t("findingsLegendLabel")}
      </span>
      {LEVELS.map((level, i) => (
        <span key={level.key} className="inline-flex items-center gap-1.5">
          {i > 0 && <span aria-hidden="true">→</span>}
          <span className="inline-flex items-center gap-1">
            <span className={cn("h-1.5 w-1.5 rounded-full", level.dot)} />
            {t(level.key)}
          </span>
        </span>
      ))}
    </p>
  )
}
